import { render, staticRenderFns } from "./DialogPlanifPostEditorial.vue?vue&type=template&id=5e2b05f4&scoped=true&"
import script from "./DialogPlanifPostEditorial.vue?vue&type=script&lang=js&"
export * from "./DialogPlanifPostEditorial.vue?vue&type=script&lang=js&"
import style0 from "./DialogPlanifPostEditorial.vue?vue&type=style&index=0&id=5e2b05f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b05f4",
  null
  
)

export default component.exports